const text = (value) => (value === null || value === undefined ? '' : String(value).trim());

export const previousServiceMonthLabel = (serviceMonth) => {
  const raw = text(serviceMonth);
  const parsed = raw ? new Date(raw) : new Date();
  const date = Number.isNaN(parsed.getTime()) ? new Date() : parsed;
  date.setUTCDate(1);
  date.setUTCMonth(date.getUTCMonth() - 1);
  return date.toLocaleString('en-US', { month: 'long', timeZone: 'UTC' });
};

export const creditNoteForServiceMonth = (serviceMonth) => `Credit for ${previousServiceMonthLabel(serviceMonth)} services`;
